import { graphql, updateUserRegistration } from '../api'
import { deleteUserMutation, sendPaymentRemindersMutation, cleanupPreviewAuctionMutation, sendSolicitationReviewRequestMutation, updateAuctionMutation } from '../graphql/Mutations'
import { adminGetAuctionByCodeQuery, adminGetAuctionImagePresignedUrlQuery, adminFindUserQuery,
         adminListAuctionsQuery, collaboratorGetAuctionByCodeQuery, adminSearchFundsQuery, adminValidateMarketingEffortQuery } from '../graphql/Queries'
import { isFullAdmin } from './permissionsutil'

export const adminFindUser = async (cognitoLogin) => {
  console.log('adminFindUser!', cognitoLogin)

  const response = await graphql({query: adminFindUserQuery, variables: {cognitoLogin}})
  if (!response?.data?.adminFindUser) {
    console.log(response)
    return({"error": response})
  }
  else {
    const user = JSON.parse(JSON.stringify(response.data.adminFindUser))

    return user
  }
}

// selects all if status is missing or 'ALL'
export const adminListAuctions = async (statusInput) => {
  console.log('adminListAuctions!', {statusInput})

  const status = statusInput || "ALL"

  const query = localStorage.isSeleniumTest ? adminListAuctionsQuery.replace('Status', 'IsForTestOnly: {eq: true}, Status') : adminListAuctionsQuery
  const response = await graphql({query, variables: {status}})

  if (!response?.data?.adminListAuctions?.items) {
    console.error("error: ", response)
  }
  else {
    const auctionList = response.data.adminListAuctions.items
    return auctionList
  }
}

export const adminSearchFunds = async (fund) => {
  console.log('adminSearchFunds!', {fund})

  const response = await graphql({query: adminSearchFundsQuery, variables: {fund}})

  if (!response?.data?.adminSearchFunds) {
    console.error("error: ", response)
  }
  else {
    return response.data.adminSearchFunds
  }
}

export const adminValidateMarketingEffort = async (meNumber) => {
  console.log('adminValidateMarketingEffort!', {meNumber})

  const response = await graphql({query:adminValidateMarketingEffortQuery, variables: {meNumber}})

  if (!response?.data?.adminValidateMarketingEffort) {
    console.error("error: ", response)
  }
  else {
    return response.data.adminValidateMarketingEffort
  }
}


// IMPORTANT: deletes Auction User only, does not delete CIDM User
export const deleteAuctionUser = async (cognitoLogin) => {
  console.log('deleteAuctionUser!')
    try {

      const response = await graphql({query: deleteUserMutation, variables: {cognitoLoginToDelete: cognitoLogin}})

      if (response.errors) {
        console.error("User not deleted: ", response.errors[0].message)
        return {error: {msg: response.errors[0].message}}
      }
      else if (!response?.data?.deleteUser?.UserId) {
        console.error("User not deleted: ", response)
        return response
      }
      else {
        const auctionUser = {UserId: response.data.deleteUser.UserId, MyAuctions: []}
        return auctionUser
      }
    }
    catch (e) {
      console.error("error in delete:", e)
      return {error: e}
    }
}


export const adminGetAuctionByCode = async (auctionCode) => {
  console.log('adminGetAuctionByCode!', auctionCode)

  const query = (isFullAdmin()) ? adminGetAuctionByCodeQuery : collaboratorGetAuctionByCodeQuery

  const response = await graphql({query, variables: {auctionCode}})
  if (!response?.data?.adminGetAuctionByCode) {
    console.log(response)
    return({"error": response})
  }
  else {
    const auction = JSON.parse(JSON.stringify(response.data.adminGetAuctionByCode))

    // TODO: commenting this out event hub syncing because we don't need it for the first auction
    // if (auction.Registrations.length !== auction.EventHubRegistrations.length)
    //   return({"error": {msg: "Mismatch between Event Hub registrations and Auction regsitrations", response}})

    // we have to do this here because AppSync doesn't allow access to nested data resolvers in the parent pipeline
    // auction.Registrations = auction.Registrations.sort((a,b) => a.EventHubRegistrationId.toLowerCase().localeCompare(b.EventHubRegistrationId))
    // auction.EventHubRegistrations = auction.EventHubRegistrations.sort((a,b) => a.RegistrationId.toLowerCase().localeCompare(b.RegistrationId))
    // auction.Registrations.forEach((reg, index) =>{
    //   reg.IsCheckedIn = auction.EventHubRegistrations[index].RegistrationStatus === "CHECKED_IN"
    // })

    // TODO - everyone who registered for the first auction is checked in already
    auction.Registrations.forEach((reg, index) =>{
      reg.IsCheckedIn = true
    })

    auction.Permissions = auction.Permissions.map((permission, index) => {
      console.log({permission})
      permission.Level = JSON.parse(permission.AdminPermissions).Edit ? "Edit" : "View"
      delete permission.AdminPermissions
      return permission
    })

    delete auction.EventHubRegistrations

    return auction
  }
}

export const adminCleanupPreviewAuction = async (auctionId) => {
  console.log('adminCleanupPreviewAuction!', auctionId)
  const response = await graphql({query: cleanupPreviewAuctionMutation, variables: {auctionId}})
  if (!response?.data?.cleanupPreviewAuction) {
    return({"error": response})
  }
  else {
    return response
  }
}

export const sendAllPaymentReminderEmails = async (auctionId) => {
  console.log('sendAllPaymentReminderEmails!')

  const response = await graphql({query: sendPaymentRemindersMutation, variables: {auctionId}})
  if (!response?.data?.sendPaymentReminders || !response.data.sendPaymentReminders.AuctionId) {
    console.log(response)
    return({"error": response})
  }
  else {
    return response
  }
}

export const sendSolicitationReviewRequest = async (auctionId) => {
  console.log('sendSolicitationReviewRequest!')

  try {
    const response = await graphql({query: sendSolicitationReviewRequestMutation, variables: {auctionId}})

    console.log('response', response)
    if (!response?.data?.sendSolicitationReviewRequest || !response.data.sendSolicitationReviewRequest.AuctionId) {
      console.log(response)
      return({"error": response})
    }
    else {
      return response
    }
   }
  catch (e) {
    console.error("error in solitication review:", e)
    return {error: e}
  }
}


export const adminGetAuctionImagePresignedUrl = async (auctionCode, itemId, fileName, contentType) => {
  console.log('adminGetAuctionImagePresignedUrl!')

  const response = await graphql({query: adminGetAuctionImagePresignedUrlQuery, variables: {auctionCode, itemId, fileName, contentType}})
  if (!response?.data?.getPresignedUrlForUpload || !response.data.getPresignedUrlForUpload.PresignedUrl) {
    console.log(response)
    return({"error": response})
  }
  else {
    const presignedUrl = response.data.getPresignedUrlForUpload.PresignedUrl

    return presignedUrl
  }
}

export const formatName = (registration) => {
  return `${registration.User.FirstName} ${registration.User.LastName}`
}

//admin sort table functions
// see ClosedItemDisplay.js for an example 

  // Handler for column header clicks
export const handleSort = (key, sortOptions, setSortOptions) => {
  let direction = 'asc'
  if (sortOptions.key === key && sortOptions.direction === 'asc') direction = 'desc'
  setSortOptions({ key, direction })
}

export const sortSpan = (columnToSort, sortOptions) => {
  if (sortOptions.key === columnToSort && sortOptions.direction === 'asc') return <span>▲</span>
  if (sortOptions.key === columnToSort && sortOptions.direction === 'desc') return <span>▼</span>
}

export const performSort = (inputArray, sortOptions) => {
  return [...inputArray].sort((a, b) => {
    if (sortOptions.key === '') return 0 // No sorting if no key is set

    const aValue = a[sortOptions.key]
    const bValue = b[sortOptions.key]

    if (typeof aValue === 'string' && typeof bValue === 'string') {
      const stringCompare = aValue.localeCompare(bValue, undefined, {
        sensitivity: 'base',
        numeric: true,
      })

      if (stringCompare < 0) return sortOptions.direction === 'asc' ? -1 : 1
      if (stringCompare > 0) return sortOptions.direction === 'asc' ? 1 : -1
      return 0
    }

    if (aValue < bValue) return sortOptions.direction === 'asc' ? -1 : 1
    if (aValue > bValue) return sortOptions.direction === 'asc' ? 1 : -1
    return 0
  })
}

//to check if the auction has at least one item for check lists
export const auctionHasItems = (auctionDetail) => {
  if (!auctionDetail) return
  const anyItems = auctionDetail?.Items?.length > 0
  const anyFixedItems = auctionDetail?.FixedItems?.length > 0

  return anyItems || anyFixedItems
}

// to check if the auction has any empty fields for check lists
export const auctionDetailsComplete = (auctionDetail) => {
  if (!auctionDetail) return false

  //fields required for the check - all are strings in the schema
  const neededDetails = ['AuctionId', 'AuctionCode', 'AuctionLocation', 'BannerImageName', 'Description', 'EndTime',
    'SupportEmail', 'FundName', 'FundNumber', 'MarketingEffortName', 'MarketingEffortNumber', 'StartTime', 'Title', 'Status']

  // check each field to see if it is
  //  A) a string (user entered value rather than null from Auction creation)
  // AND 
  //  B) has a length > 0 (user has a valid value instead of entering then deleting)

  for (let i=0; i < neededDetails.length; i++) {
    const key = neededDetails[i]
    if (typeof(auctionDetail[key]) !== 'string') return false
    if (auctionDetail[key].length === 0) return false
  }
  //if all required fields are strings and have a length, auction details considered complete
  return true
}

export const areAllChargesPaid = (auctionDetail) => {
  if (!auctionDetail) return false
  
  //filter out unclaimed items, and return only if they are paid off
  const wonCheck = auctionDetail.Items.filter(item => item.BidCount > 0).map(item => item.Paid)
  
  //filter out fixed price with no purchases
  const purchasedCheck = auctionDetail.FixedItems.filter(item => item.TotalItemsPurchased > 0).map( item => {
    // sum up all payment quantities
    const totalQuantity = item.Payments.reduce((sum, payment) => {
      return sum + (payment.Quantity || 0)
    }, 0)
    //map the paid value for fixed item
    return totalQuantity === item.TotalItemsPurchased
  })
  
  // check to see if all donations are paid
  let donationCheck = auctionDetail.Registrations.map(reg => {
    if (reg.DonationTotal > 0) {
      return reg.DonationPayment !== null
    } else {
      return true
    }
  })

  // console.log('wonCheck', wonCheck)
  // console.log('purchasedCheck', purchasedCheck)
  // console.log('donationCheck', donationCheck)
  
  const allCharges = [...wonCheck, ...purchasedCheck, ...donationCheck]
  
  const allTrue = (currentValue) => currentValue === true
  return allCharges.every(allTrue)
}

export const solicitationStatusDecoder = {
    'Submitted': 'Awaiting Solicitation Review Approval',
    'Approved': 'Approved',
    'Removed': 'Approval Revoked',
  }


  // to create admin summary for display tables 
export const summarizePurchases = (purchasePrice, purchases) => {
  const map = {}

  for (const p of purchases) {
    if (!map[p.UserId]) {
      map[p.UserId] = { FullName: p.FullName, Quantity: 0 }
    }
    map[p.UserId].Quantity += p.Quantity
  }

  const users = Object.values(map).map(u => ({ FullName: u.FullName, Quantity: u.Quantity, AmountOwed: u.Quantity * purchasePrice }))
  const totalQuantity = users.reduce((sum, u) => sum + u.Quantity, 0)

  return {
    Users: users,
    Totals: { BuyerCount: users.length, AmountRaised: totalQuantity * purchasePrice }
  }
}

export const getUserPurchases = (userId, auction) => {
  if (!auction?.FixedItems?.length) return []

  return auction.FixedItems
    .map((item) => {
      const userPurchases = item.Purchases?.filter((purchase) => purchase.UserId === userId) || []
      const quantity = userPurchases.reduce((sum, purchase) => sum + (purchase.Quantity || 0), 0)
      if (quantity === 0) return null
      return { FixedItemId: item.FixedItemId, Title: item.Title, Quantity: quantity, AmountOwed: quantity * (item.PurchasePrice || 0)}
    })
    .filter(Boolean) //cleans up array by removing null entries
}

export const generateAllUserPaidStatus = (auctionDetail) => {

    const itemObj = buildItemObjByUser(auctionDetail)
    const fixedItemObj = buildFixedItemObjByUser(auctionDetail)
    const donationObj = buildDonationObj(auctionDetail)

    const totalObj = combineAuctionUserObjects(itemObj, fixedItemObj, donationObj)

    //need to clarify if we need to display multiple transaction ids, not gift and non-gift, but if there are two payments made
    return totalObj
}

const buildItemObjByUser = (auctionDetail) => {

    const itemObj = {}

  if (!auctionDetail?.Items?.length) return itemObj

// item object contruction from ClosedAttendeeView
    auctionDetail.Items.forEach((item) => {
        
        const winner = item.CurrentHighBidder
        const bid = item.CurrentBid
        const paid = item.Paid

        if (!itemObj[winner]) {
            itemObj[winner] = {
                itemsWon: 0,
                totalDue: 0,
                totalPaid: 0,
                transactions: {}
            }
        }

        itemObj[winner].itemsWon += 1

        if (paid) {
          itemObj[winner].totalPaid += bid

          const paymentDetails = JSON.parse(item.PaymentDetails)
          const Transactions = {}

          if (paymentDetails.message) {
            Transactions[item.Title] = paymentDetails.message
          }
          else {
            if (paymentDetails.ccLambdaResponses?.gift.success) Transactions.gift = paymentDetails.ccLambdaResponses.gift.ccLambdaResponse.transactionNumber
            if (paymentDetails.ccLambdaResponses?.nonGift.success) Transactions.nonGift = paymentDetails.ccLambdaResponses.nonGift.ccLambdaResponse.transactionNumber
          }

          itemObj[winner].transactions = Transactions
        } else {
            itemObj[winner].totalDue += bid
        }

      })

      return itemObj
}

const buildFixedItemObjByUser = (auctionDetail) => {
  const fixedItemObj = {}

  if (!auctionDetail?.FixedItems?.length) return fixedItemObj

  auctionDetail.FixedItems.forEach((item) => {
    const purchaseGroups = {};

    // Group purchases by user for this fixed item
    (item.Purchases || []).forEach((purchase) => {
      const userId = purchase.UserId

      if (!purchaseGroups[userId]) {
        purchaseGroups[userId] = {
          userId,
          quantity: 0
        }
      }

      purchaseGroups[userId].quantity += purchase.Quantity || 0
    })

    // Group payments by user for this fixed item
    const paymentGroups = {};

    (item.Payments || []).forEach((payment) => {
      const userId = payment.UserId

      if (!paymentGroups[userId]) {
        paymentGroups[userId] = []
      }

      paymentGroups[userId].push(payment)
    });

    // Update the top-level object for each user who purchased this item
    Object.values(purchaseGroups).forEach(({ userId, quantity }) => {
      const amount = quantity * (item.PurchasePrice || 0)
      const userPayments = paymentGroups[userId] || []
      const hasPayment = userPayments.length > 0

      if (!fixedItemObj[userId]) {
        fixedItemObj[userId] = {
          itemsWon: 0,
          totalDue: 0,
          totalPaid: 0,
          transactions: {}
        }
      }

      fixedItemObj[userId].itemsWon += 1

      if (hasPayment) {
        fixedItemObj[userId].totalPaid += amount

        const itemTransactions = {}

        userPayments.forEach((payment) => {
          if (!payment.PaymentDetails) return

          let paymentDetails
          try {
            paymentDetails =
              typeof payment.PaymentDetails === "string"
                ? JSON.parse(payment.PaymentDetails)
                : payment.PaymentDetails
          } catch {
            return
          }

          if (paymentDetails.message) {
            itemTransactions[item.Title] = paymentDetails.message
          } else {
            if (paymentDetails.ccLambdaResponses?.gift?.success) itemTransactions.gift = paymentDetails.ccLambdaResponses.gift.ccLambdaResponse.transactionNumber
            if (paymentDetails.ccLambdaResponses?.nonGift?.success) itemTransactions.nonGift = paymentDetails.ccLambdaResponses.nonGift.ccLambdaResponse.transactionNumber
          }
        })

        if (Object.keys(itemTransactions).length > 0) {
          fixedItemObj[userId].transactions[item.Title] = itemTransactions
        }
      } else {
        fixedItemObj[userId].totalDue += amount
      }
    })
  })

  return fixedItemObj
}

const buildDonationObj = (auctionDetail) => {
  const donationObj = {}

  if (!auctionDetail?.Registrations?.length) return donationObj

  auctionDetail.Registrations.forEach((registration) => {
    const userId = registration?.User?.UserId
    if (!userId) return

    const donationTotal = registration.DonationTotal || 0
    const isPaid = !!registration.DonationPayment

    if (!donationObj[userId]) {
      donationObj[userId] = {
        donationCount: 0,
        totalDue: 0,
        totalPaid: 0,
        transactions: {}
      }
    }

    donationObj[userId].donationCount += 1

    if (isPaid) {
      donationObj[userId].totalPaid += donationTotal

      const registrationTransactions = {}

      let donationPayment
      try {
        donationPayment =
          typeof registration.DonationPayment === "string"
            ? JSON.parse(registration.DonationPayment)
            : registration.DonationPayment
      } catch {
        donationPayment = null
      }

      if (donationPayment?.message) {
        registrationTransactions[registration.RegistrationId] = donationPayment.message
      } else {
        if (donationPayment?.ccLambdaResponses?.gift?.success) registrationTransactions.gift = donationPayment.ccLambdaResponses.gift.ccLambdaResponse.transactionNumber
        if (donationPayment?.ccLambdaResponses?.nonGift?.success) registrationTransactions.nonGift = donationPayment.ccLambdaResponses.nonGift.ccLambdaResponse.transactionNumber
      }

      if (Object.keys(registrationTransactions).length > 0) {
        donationObj[userId].transactions[registration.RegistrationId] = registrationTransactions
      }
    } else {
      donationObj[userId].totalDue += donationTotal
    }
  })

  return donationObj
}

const combineAuctionUserObjects = (itemObj = {}, fixedItemObj = {}, donationObj = {}) => {
  const combined = {}
  const userIds = new Set([ ...Object.keys(itemObj), ...Object.keys(fixedItemObj), ...Object.keys(donationObj)])

  for (const userId of userIds) {
    const itemData = itemObj[userId] || {}
    const fixedData = fixedItemObj[userId] || {}
    const donationData = donationObj[userId] || {}

    combined[userId] = {
      totalDue: (itemData.totalDue || 0) + (fixedData.totalDue || 0) + (donationData.totalDue || 0),
      totalPaid:(itemData.totalPaid || 0) + (fixedData.totalPaid || 0) + (donationData.totalPaid || 0),
      itemsWon: (itemData.itemsWon || 0) + (fixedData.itemsWon || 0),

      transactions: itemData.transactions || {}
    };
  }

  return combined
}

export const buildManageCheckoutFixedItemRow = (item, userId) => {
  const purchasedQuantity = (item.Purchases || []).reduce((sum, purchase) => {
    if (purchase.UserId !== userId) return sum
    return sum + (purchase.Quantity || 0)
  }, 0)

  if (purchasedQuantity === 0) return null

  const paidQuantity = (item.Payments || []).reduce((sum, payment) => {
    if (payment.UserId !== userId) return sum
    return sum + (payment.Quantity || 0)
  }, 0)

  const outstandingQuantity = Math.max(purchasedQuantity - paidQuantity, 0)
  const totalAmount = purchasedQuantity * (item.PurchasePrice || 0)

  return {
    ...item,
    Quantity: purchasedQuantity,
    PaidQuantity: paidQuantity,
    OutstandingQuantity: outstandingQuantity,
    AmountDue: outstandingQuantity * (item.PurchasePrice || 0),
    TotalAmount: totalAmount,
    Paid: outstandingQuantity === 0,
    rowId: item.FixedItemId,
    rowType: 'fixedItem',
  }
}

export const buildManageCheckoutDonationRow = (registration) => {
  if (!registration || registration.DonationTotal <= 0) return null

  return {
    ...registration,
    Title: 'Donation',
    Quantity: 'N/A',
    AmountDue: registration.DonationPayment ? 0 : registration.DonationTotal,
    TotalAmount: registration.DonationTotal,
    Paid: !!registration.DonationPayment,
    rowId: registration.RegistrationId,
    rowType: 'donation',
  }
}

export const buildManageCheckoutBidItemRow = (item) => {
  return {
    ...item,
    Quantity: 'N/A',
    AmountDue: item.Paid ? 0 : item.CurrentBid,
    TotalAmount: item.CurrentBid,
    rowId: item.ItemId,
    rowType: 'item',
  }
}

//gets the total amount on the attendee page during a live auction
export const getUserTotalAmount = (auction, userId) => {

  let total = 0

  ;(auction?.Items || []).forEach((item) => {
    if (item.CurrentHighBidder === userId) {
      total += Number(item.CurrentBid) || 0
    }
  })

  ;(auction?.FixedItems || []).forEach((fixedItem) => {
    const purchasePrice = Number(fixedItem.PurchasePrice) || 0

    ;(fixedItem.Purchases || []).forEach((purchase) => {
      if (purchase.UserId === userId) {
        total += (Number(purchase.Quantity) || 0) * purchasePrice
      }
    })
  })

  const registration = (auction?.Registrations || auction?.Registration || []).find((reg) => reg?.User?.UserId === userId)

  if (registration) {
    total += Number(registration.DonationTotal) || 0
  }

  return total
}

const richTextAllowedTags = new Set(['a', 'br', 'em', 'li', 'ol', 'p', 'strong', 'u', 'ul'])
const richTextAllowedAttributes = {
  a: ['href', 'rel', 'target'],
}

const escapeRichTextText = (value = '') => value
  .replaceAll('&', '&amp;')
  .replaceAll('<', '&lt;')
  .replaceAll('>', '&gt;')
  .replaceAll('"', '&quot;')
  .replaceAll('\\', '&#92;')

const escapeRichTextAttribute = (value = '') => String(value)
  .replaceAll('&', '&amp;')
  .replaceAll('"', '&quot;')
  .replaceAll("'", '&#39;')
  .replaceAll('\\', '&#92;')

const serializeRichTextNode = (node) => {
  if (node.nodeType === Node.TEXT_NODE) {
    return escapeRichTextText(node.textContent || '')
  }

  if (node.nodeType !== Node.ELEMENT_NODE) {
    return ''
  }

  const tagName = node.tagName.toLowerCase()
  const childMarkup = Array.from(node.childNodes).map(serializeRichTextNode).join('')

  if (!richTextAllowedTags.has(tagName)) {
    return childMarkup
  }

  if (tagName === 'br') {
    return '<br/>'
  }

  const attributes = (richTextAllowedAttributes[tagName] || [])
    .map((attributeName) => {
      const attributeValue = node.getAttribute(attributeName)

      if (attributeValue === null) return ''

      return ` ${attributeName}='${escapeRichTextAttribute(attributeValue)}'`
    })
    .join('')

  return `<${tagName}${attributes}>${childMarkup}</${tagName}>`
}

export const normalizeRichTextForStorage = (value = '') => {
  const trimmedValue = value?.trim?.() || ''

  if (!trimmedValue) return ''

  if (!trimmedValue.startsWith('<')) return trimmedValue

  const parsedDocument = new DOMParser().parseFromString(trimmedValue, 'text/html')
  const plainText = parsedDocument.body.textContent?.trim() || ''
  if (!plainText) return ''

  return Array.from(parsedDocument.body.childNodes).map(serializeRichTextNode).join('')
}

export const getClassName = (...classes) => classes.filter(Boolean).join(' ')

export const LinkIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M10.6 13.4a1 1 0 0 1 0-1.4l3-3a3 3 0 0 1 4.2 4.2l-2.1 2.1a3 3 0 0 1-4.2 0" />
    <path d="M13.4 10.6a1 1 0 0 1 0 1.4l-3 3a3 3 0 0 1-4.2-4.2l2.1-2.1a3 3 0 0 1 4.2 0" />
  </svg>
)

export const UnlinkIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M9.8 14.2a3 3 0 0 1-4.2 0 3 3 0 0 1 0-4.2l2.1-2.1a3 3 0 0 1 4.2 0" />
    <path d="M14.2 9.8a3 3 0 0 1 4.2 0 3 3 0 0 1 0 4.2l-2.1 2.1a3 3 0 0 1-4.2 0" />
    <path d="M4 20 20 4" />
  </svg>
)

export const BulletListIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="5" cy="7" r="1.6" />
    <circle cx="5" cy="12" r="1.6" />
    <circle cx="5" cy="17" r="1.6" />
    <path d="M9 7h10" />
    <path d="M9 12h10" />
    <path d="M9 17h10" />
  </svg>
)

export const isTitleDuplicated = (input, array) => {
  const normalizedInput = input.trim().toLowerCase()
  
  for (let i = 0; i < array.length; i++) {
    if (array[i].Title.trim().toLowerCase() === normalizedInput) return true
  }
  return false
}

export const generateItemLink = (itemCode, auctionCode) => {
  if (!itemCode || !auctionCode) return ''
  return `${window.location.origin}/auction/item?auctionId=${encodeURIComponent(auctionCode)}&itemId=${encodeURIComponent(itemCode)}`
}

export const generateFixedItemLink = (itemCode, auctionCode) => {
  if (!itemCode || !auctionCode) return ''
  return `${window.location.origin}/auction/fixeditem?auctionId=${encodeURIComponent(auctionCode)}&fixedItemId=${encodeURIComponent(itemCode)}`
}
